// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__1V332","bigTitle":"style_bigTitle__IJ28p","propertiesContainer":"style_propertiesContainer__34eFn","center":"style_center__2iquk"};